import {React, useState,useEffect} from 'react'
import './Banner.css'
import axios from './axios'
import requests from './Requests'

function Banner() {

  const [movie, setMovie] = useState([])

  useEffect(() =>{
    async function fetchData() {
      const request = await axios.get(requests.fetchNetflixOriginals);
      setMovie(request.data.results[Math.floor(Math.random()* request.data.results.length -1)])
      return request;
    }
    fetchData();
  }, [])
  console.log(movie);

  function truncate(str, n){
    return str?.length > n? str.substring(0, n-1) + "..." : str; 
  }

  return (
    <header className='banner' 
    style={{backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`, backgroundSize: 'cover', 
    backgroundPosition: 'center', 
    backgroundRepeat:'no-repeat'}}>
      <div className='banner_contents'>
      <h1 className='banner_title'>
        {movie?.original_name || movie?.title || movie?.name}
        </h1>
      <div className='banner_buttons'>
        <button className='banner_button'>Play</button>
        <button className='banner_button'>My List</button>
      </div>
      <h1 className='banner_desc'>{ truncate(movie?.overview, 150 )}</h1>
      </div>
      <div className='banner_fadeBottom' />

    </header>
  )
}

export default Banner
